import { RowBetween } from 'components/Row'
import styled from 'styled-components/macro'

export const ModalHeader = styled(RowBetween)`
  flex-direction: column;
  align-items: center;
  margin-top: -1rem;
  width: 100%;
`
